import {
    orderGeneralInfoDecoder,
    OrderGeneralInformation
} from '../../../Entities/OrderGeneralInformation'
import {GeneralInformationTab} from './GeneralInformationState'
import {GeneralInformationSubAction} from './GeneralInformationActions'
import {OrderDetailsFeedback} from '../OrderDetailsFeedback'
import {update} from '../../../Data/ObjectHelper'
import * as Editable from '../../../Data/Editable'
import * as OrderResource from '../../../Request/OrderResource'
import {decodeHttpResponse} from '../../../Data/Http'
import {orderDecoder} from '../../../Entities/Order'
import {OrderPaid} from '../../../Entities/OrderPaid'
import {FeedbackLoop} from '../../../Data/FeedbackLoop'

export function initGeneralInformation(
    orderPaid: OrderPaid,
    generalInformation: OrderGeneralInformation
): GeneralInformationTab {
    return {
        orderPaid,
        generalInformation,
        generalInformationForm: {type: 'Locked'},
    }
}

type GeneralInformationLoop =
    FeedbackLoop<GeneralInformationTab, OrderDetailsFeedback>

export function generalInformationReducer(
    orderId: number,
    state: GeneralInformationTab,
    action: GeneralInformationSubAction
): GeneralInformationLoop {
    switch (action.type) {
        case 'OrderPaidChanged':
            return {
                state,
                feedback: [{
                    type: 'SendRequest',
                    identifier: {
                        type: 'OrderPaidPatch',
                        orderId: orderId,
                    },
                    httpRequest: OrderResource.patchOrderPaid(
                        action.checked ? 'Paid' : 'Unpaid',
                        orderId,
                    ),
                }],
            }
        case 'OrderPaidResponse': {
            const result = decodeHttpResponse(
                orderDecoder(),
                action.result)
            if (result.type === 'Ok') {
                return {
                    state: update({
                        orderPaid: result.value.orderPaid,
                    }, state),
                    feedback: [],
                }
            } else {
                return {
                    state: state,
                    feedback: [],
                }
            }
        }
        case 'EditDetails': {
            return {
                state: update({
                    generalInformationForm: {
                        type: 'Pending',
                        value: state.generalInformation,
                    },
                }, state),
                feedback: [],
            }
        }
        case 'OrderVatIdChanged':
            return updateGeneralInformationForm(
                orderDetails => update(({
                    vatId: action.value,
                }), orderDetails),
                state)
        case 'SaveDetails': {
            const {generalInformationForm} = state
            if (generalInformationForm.type === 'Pending' || generalInformationForm.type === 'Failure') {
                const generalInformation = generalInformationForm.value
                return {
                    state: update({
                        generalInformationForm: {
                            type: 'Loading',
                            value: generalInformation,
                        },
                    }, state),
                    feedback: [{
                        type: 'SendRequest',
                        identifier: {type: 'OrderGeneralInfoPatch'},
                        httpRequest:
                            OrderResource.patchGeneralInformation(
                                generalInformation,
                                orderId,
                            )
                    }],
                }
            }
            return {state, feedback: []}
        }
        case 'OrderGeneralInfoPatchResponse': {
            const result =
                decodeHttpResponse(
                    orderGeneralInfoDecoder(),
                    action.result)
            if (state.generalInformationForm.type !== 'Locked') {
                return (() => {
                    switch (result.type) {
                        case 'Ok':
                            return {
                                state: update({
                                    generalInformation: result.value,
                                    generalInformationForm: {
                                        type: 'Locked',
                                    }
                                }, state),
                                effects: [],
                                feedback: [],
                            }
                        case 'Err':
                            return {
                                state: update({
                                    generalInformationForm: {
                                        type: 'Failure',
                                        value: state.generalInformationForm.value,
                                        error: result.error,
                                    }
                                }, state),
                                effects: [],
                                feedback: [],
                            }
                    }
                })()
            } else {
                return {state, feedback: []}
            }
        }
        case 'DiscardDetails': {
            return {
                state: update({
                    generalInformationForm: {
                        type: 'Locked',
                    },
                }, state),
                feedback: [],
            }
        }
    }
}

function updateGeneralInformationForm(
    fn: (generalInformation: OrderGeneralInformation) => OrderGeneralInformation,
    state: GeneralInformationTab
): GeneralInformationLoop {
    return {
        state: update({
            generalInformationForm:
                Editable.map(
                    fn,
                    state.generalInformationForm),
        }, state),
        feedback: [],
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderDetails/GeneralInformation/GeneralInformationReducer.ts